
import type { App } from 'vue'
import imgClick from './modules/imgClick'
 
const directivesList: any = {
  'img-click':imgClick
}
 
const setDirectives = {
  install(app: App<Element>) {
    Object.keys(directivesList).forEach((key) => {
      app.directive(key, directivesList[key])
    })
  },
}
 
export default setDirectives